import React from 'react';

export const withEmptyLayout = (LoadedComponent) => {
    class EmptyLayout extends React.Component {
        render() {
            return <LoadedComponent/>
        }
    }
    return EmptyLayout;
};